import React from 'react';

const FormTitle = ({ title, margin = 'mb-8' }) => {
  return <h3 className={`border-b-2 ${margin} pb-2 uppercase font-semibold text-gray-700`}>{title}</h3>;
};

export default FormTitle;
